<template>
    <div class="mx-2">
        <div class="card relative bg-base-100 shadow-lg border border-base-200 overflow-hidden h-[calc(100vh-5rem)] flex flex-col">
            <div class="card-body p-0 flex flex-col flex-1 min-h-0 bg-base-200">
                

                <div class="grid gap-0 lg:grid-cols-[250px_minmax(0,1fr)] xl:grid-cols-[270px_minmax(0,1fr)] log-overview-shell flex-1 min-h-0">
                    <aside class="border-b border-base-200/80 lg:border-b-0 lg:border-r lg:border-base-200/80 log-overview-sidebar overflow-y-auto shadow-lg">
                        <div class="p-3.5">
                            <div class="tabs tabs-boxed w-full bg-base-100/70 p-1 shadow-sm">
                                <button
                                    class="tab flex-1"
                                    :class="{ 'tab-active': tabSelect2 === 'log' }"
                                    @click="handleTab2('log')"
                                >{{ $tt('操作日志') }}</button>
                                <button
                                    v-if="getUserRole === 'V2'"
                                    class="tab flex-1"
                                    :class="{ 'tab-active': tabSelect2 === 'runtime' }"
                                    @click="handleTab2('runtime')"
                                >{{ $tt('运行日志') }}</button>
                            </div>

                            <div v-if="tabSelect2 === 'log'" class="mt-4 space-y-2">
                                <button
                                    v-for="action in visibleActionOptions"
                                    :key="action.value"
                                    class="w-full rounded-[18px] px-4 py-3 text-left transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
                                    :class="navRowClass(currentActionKey === action.key)"
                                    @click="selectAction(action.key)"
                                >
                                    <div class="flex items-center justify-between gap-3">
                                        <div class="min-w-0">
                                            <div class="flex items-center gap-2 flex-wrap">
                                                <div class="text-sm font-semibold text-base-content">{{ $tt(action.label) }}</div>
                                                <div class="badge badge-sm border-0 font-medium" :class="softBadgeClass(action.tone)">
                                                    {{ $tt(action.badge) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="shrink-0 text-right">
                                            <div class="text-lg font-semibold text-base-content">{{ getActionCountValue(action.key) }}</div>
                                        </div>
                                    </div>
                                </button>
                            </div>

                            <div v-else class="mt-4 space-y-2">
                                <button
                                    v-for="runtime in runtimeOptions"
                                    :key="runtime.value"
                                    class="w-full rounded-[18px] px-4 py-3 text-left transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
                                    :class="navRowClass(tabSelectRuntime === runtime.value)"
                                    @click="selectRuntime(runtime.value)"
                                >
                                    <div class="flex items-center justify-between gap-3">
                                        <div class="min-w-0">
                                            <div class="flex items-center gap-2 flex-wrap">
                                                <div class="text-sm font-semibold text-base-content">{{ runtime.label }}</div>
                                                <div class="badge badge-sm border-0 font-medium" :class="softBadgeClass(runtime.tone)">
                                                    {{ $tt(runtime.badge) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </aside>

                    <section class="min-w-0 bg-base-200 overflow-hidden overflow-y-auto log-overview-detail rounded-2xl">
                        <div v-if="tabSelect2 === 'log'" class="px-6 py-6 bg-base-200">
                            <div class="flex flex-col gap-4 rounded-[24px] bg-base-100/65 px-5 py-5 shadow-md">
                                <div class="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                                    <div class="min-w-0">
                                        <div class="flex items-center gap-3 flex-wrap">
                                            <h3 class="text-2xl font-semibold text-base-content">{{ activeActionLabel }}</h3>
                                            <div class="badge badge-lg border-0 font-medium" :class="softBadgeClass('info')">
                                                {{ $tt('第 {page} 页', { page: currentPage }) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                                        <label class="form-control w-full">
                                            <span class="mb-1.5 text-xs uppercase tracking-[0.18em] text-base-content/45">{{ $tt('日志等级') }}</span>
                                            <select class="select select-sm w-full border-0 bg-base-100/90 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/20" v-model="levelFilter" @change="handleFilterChange">
                                                <option value="">{{ $tt('全部等级') }}</option>
                                                <option value="info">{{ $tt('信息') }}</option>
                                                <option value="warning">{{ $tt('警告') }}</option>
                                                <option value="error">{{ $tt('错误') }}</option>
                                            </select>
                                        </label>

                                        <label class="form-control w-full">
                                            <span class="mb-1.5 text-xs uppercase tracking-[0.18em] text-base-content/45">{{ $tt('状态') }}</span>
                                            <select class="select select-sm w-full border-0 bg-base-100/90 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/20" v-model="statusFilter" @change="handleFilterChange">
                                                <option value="">{{ $tt('全部状态') }}</option>
                                                <option value="running">{{ $tt('进行中') }}</option>
                                                <option value="success">{{ $tt('成功') }}</option>
                                                <option value="stop">{{ $tt('停止') }}</option>
                                                <option value="wait">{{ $tt('等待') }}</option>
                                                <option value="failed">{{ $tt('失败') }}</option>
                                            </select>
                                        </label>

                                        <label class="form-control w-full sm:col-span-2 xl:col-span-1">
                                            <span class="mb-1.5 text-xs uppercase tracking-[0.18em] text-base-content/45">{{ $tt('用户') }}</span>
                                            <input
                                                type="text"
                                                class="input input-sm w-full border-0 bg-base-100/90 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/20"
                                                :placeholder="$tt('搜索用户')"
                                                v-model="userFilter"
                                                @input="handleFilterChange"
                                            >
                                        </label>

                                        <div class="flex items-end gap-2 sm:col-span-2 xl:col-span-1">
                                            <button class="btn btn-sm btn-outline flex-1 whitespace-nowrap" @click="resetFilters">
                                                {{ $tt('清空筛选') }}
                                            </button>
                                            <button
                                                class="btn btn-sm btn-error btn-outline flex-1 whitespace-nowrap"
                                                @click="handleDeleteAuditLogs"
                                            >
                                                {{ $tt('删除日志') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-5">
                                <div v-if="auditLogData.length === 0" class="rounded-[24px] bg-base-100 py-14 text-center text-base-content/55 shadow-md">
                                    <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-[20px] bg-base-200/80 text-base-content/45">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                    </div>
                                    <div class="mt-4 text-lg font-semibold text-base-content">{{ $tt('暂无操作日志') }}</div>
                                    <div class="mt-2 text-sm leading-6 text-base-content/55">
                                        {{ $tt('当前筛选条件下没有找到相关日志记录') }}
                                    </div>
                                </div>

                                <div v-else class="overflow-hidden rounded-[24px] bg-base-100/95 shadow-lg">
                                    <div class="hidden lg:block overflow-x-auto">
                                        <table class="table log-overview-table">
                                            <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>{{ $tt('用户') }}</th>
                                                <th class="whitespace-nowrap min-w-[8rem]">{{ $tt('操作') }}</th>
                                                <th>{{ $tt('等级 / 状态') }}</th>
                                                <th>{{ $tt('详情摘要') }}</th>
                                                <th>{{ $tt('时间') }}</th>
                                                <th class="whitespace-nowrap min-w-[7rem]">{{ $tt('操作') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr
                                                v-for="item in auditLogData"
                                                :key="item.id"
                                                class="border-t border-base-200/80 cursor-pointer"
                                                @click="openLogDrawer(item)"
                                            >
                                                <td class="align-top font-mono text-sm">#{{ item.id }}</td>
                                                <td class="align-top">
                                                    <div class="min-w-0">
                                                        <div class="font-medium text-base-content">{{ item.user || '-' }}</div>
                                                    </div>
                                                </td>
                                                <td class="align-top whitespace-nowrap">
                                                    <div class="badge badge-outline font-medium whitespace-nowrap">{{ $tt(item.action || '-') }}</div>
                                                </td>
                                                <td class="align-top">
                                                    <div class="flex flex-col items-start gap-2">
                                                        <div class="badge badge-sm border-0 font-medium" :class="levelBadgeClass(item.level)">
                                                            {{ item.level || '-' }}
                                                        </div>
                                                        <div :class="['badge badge-sm gap-1 border-0 font-medium', statusBadgeClass(item.status)]">
                                                            <span v-if="item.status === 'running'" class="w-1.5 h-1.5 rounded-full bg-current animate-ping"></span>
                                                            <span v-else class="w-1.5 h-1.5 rounded-full bg-current"></span>
                                                            {{ getStatusText(item.status) }}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="align-top">
                                                    <div class="text-sm leading-6 text-base-content/70 log-summary-clamp">
                                                        {{ item.extra || '-' }}
                                                    </div>
                                                </td>
                                                <td class="align-top">
                                                    <div class="text-sm font-mono text-base-content/70 whitespace-nowrap">{{ item.created_at || '-' }}</div>
                                                </td>
                                                <td class="align-top whitespace-nowrap">
                                                    <div class="flex gap-2 whitespace-nowrap">
                                                        <button
                                                            v-if="canViewDetail(item.action)"
                                                            class="scrape-action-btn scrape-action-btn--strong"
                                                            @click.stop="handleRedirect(item)"
                                                        >{{ $tt('详情') }}</button>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="lg:hidden p-3 space-y-3">
                                        <button
                                            v-for="item in auditLogData"
                                            :key="item.id"
                                            class="w-full rounded-[22px] border border-base-300/80 bg-base-100/85 p-4 text-left shadow-md transition-all duration-200 hover:bg-base-200/60 hover:shadow-lg"
                                            @click="openLogDrawer(item)"
                                        >
                                            <div class="flex items-start justify-between gap-3">
                                                <div class="min-w-0">
                                                    <div class="flex items-center gap-2 flex-wrap">
                                                        <div class="font-mono text-xs rounded-full bg-base-200 px-2.5 py-1">#{{ item.id }}</div>
                                                        <div class="font-semibold text-base-content">{{ item.user || '-' }}</div>
                                                        <div class="badge badge-sm border-0 font-medium" :class="levelBadgeClass(item.level)">
                                                            {{ item.level || '-' }}
                                                        </div>
                                                    </div>
                                                    <div class="mt-2 flex items-center gap-2 flex-wrap">
                                                        <div class="badge badge-outline">{{ $tt(item.action || '-') }}</div>
                                                        <div :class="['badge badge-sm gap-1 border-0 font-medium', statusBadgeClass(item.status)]">
                                                            <span v-if="item.status === 'running'" class="w-1.5 h-1.5 rounded-full bg-current animate-ping"></span>
                                                            <span v-else class="w-1.5 h-1.5 rounded-full bg-current"></span>
                                                            {{ getStatusText(item.status) }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-xs text-base-content/45 whitespace-nowrap">
                                                    {{ formatCreatedTime(item.created_at) }}
                                                </div>
                                            </div>
                                            <div class="mt-3 text-sm leading-6 text-base-content/68 log-summary-clamp">
                                                {{ item.extra || '-' }}
                                            </div>
                                            <div class="mt-4 flex flex-wrap gap-2">
                                                <span v-if="canViewDetail(item.action)" class="scrape-action-btn scrape-action-btn--strong">
                                                    {{ $tt('支持详情页') }}
                                                </span>
                                            </div>
                                        </button>
                                    </div>

                                    <div class="flex flex-col gap-3 border-t border-base-300/70 px-4 py-3 md:flex-row md:items-center md:justify-between">
                                        <div class="text-sm text-base-content/55">
                                            {{ $tt('共 {total} 条记录，第 {page} 页', { total: totalRecords, page: currentPage }) }}
                                        </div>
                                        <div class="flex flex-wrap items-center gap-2">
                                            <div class="join">
                                                <button class="join-item btn btn-sm" :disabled="currentPage === 1" @click="handlePageChange(currentPage - 1)">«</button>
                                                <button class="join-item btn btn-sm">{{ currentPage }}</button>
                                                <button class="join-item btn btn-sm" :disabled="!hasNextPage" @click="handlePageChange(currentPage + 1)">»</button>
                                            </div>
                                            <input
                                                type="number"
                                                class="input input-bordered input-sm w-24"
                                                v-model.number="jumpPage"
                                                min="1"
                                                :placeholder="$tt('页码')"
                                                @keyup.enter="handlePageChange(Number(jumpPage))"
                                            >
                                            <button class="btn btn-sm btn-primary" @click="handlePageChange(Number(jumpPage))">{{ $tt('跳转') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="px-6 py-6 h-full">
                            <div class="flex flex-col gap-4 rounded-[24px] bg-base-100/65 px-5 py-5 shadow-md">
                                <div class="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                                    <div class="min-w-0">
                                        <div class="flex items-center gap-3 flex-wrap">
                                            <h3 class="text-2xl font-semibold text-base-content">{{ activeRuntimeLabel }}</h3>
                                            <div class="badge badge-lg border-0 font-medium" :class="softBadgeClass(isPolling ? 'success' : 'warning')">
                                                {{ isPolling ? $tt('轮询中') : $tt('已暂停') }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid gap-3 sm:grid-cols-3">
                                        <label class="form-control w-full">
                                            <span class="mb-1.5 text-xs uppercase tracking-[0.18em] text-base-content/45">{{ $tt('轮询间隔') }}</span>
                                            <div class="join w-full">
                                                <input type="number" class="join-item input input-bordered input-sm w-full bg-base-100/90" v-model.number="pollInterval" min="1" max="60">
                                                <span class="join-item btn btn-sm btn-disabled">{{ $tt('秒') }}</span>
                                            </div>
                                        </label>
                                        <div class="flex items-end">
                                            <button :class="['btn btn-sm w-full', isPolling ? 'btn-outline btn-error' : 'btn-outline btn-success']" @click="togglePolling">
                                                {{ isPolling ? $tt('停止') : $tt('开始') }}
                                            </button>
                                        </div>
                                        <div class="flex items-end">
                                            <button class="btn btn-sm btn-primary w-full" @click="openDownloadDialog">
                                                {{ $tt('反馈日志') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-sm text-base-content/50">
                                    {{ $tt('root用户的日志重定向到docker的logs输出里，请查看docker的logs输出。') }}
                                </div>
                            </div>

                            <div class="mt-5 grid gap-4 xl:grid-cols-2 h-[calc(100%-10.5rem)] min-h-[420px]">
                                <div class="overflow-hidden rounded-[24px] border border-base-300/70 bg-base-100/92 shadow-lg flex flex-col min-h-0">
                                    <div class="flex items-center gap-2 border-b border-base-300/70 px-5 py-4 bg-success/8">
                                        <div class="w-2 h-2 rounded-full bg-success"></div>
                                        <div class="font-semibold text-success">{{ $tt('运行日志') }}</div>
                                    </div>
                                    <div class="flex-1 p-4 min-h-0">
                                        <textarea
                                            ref="logTextarea"
                                            class="textarea log-textarea w-full h-full font-mono text-sm resize-none"
                                            :placeholder="$tt('等待运行日志...')"
                                            v-model="runtimeText"
                                            readonly
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="overflow-hidden rounded-[24px] border border-base-300/70 bg-base-100/92 shadow-lg flex flex-col min-h-0">
                                    <div class="flex items-center gap-2 border-b border-base-300/70 px-5 py-4 bg-error/8">
                                        <div class="w-2 h-2 rounded-full bg-error"></div>
                                        <div class="font-semibold text-error">{{ $tt('错误日志') }}</div>
                                    </div>
                                    <div class="flex-1 p-4 min-h-0">
                                        <textarea
                                            ref="failLogTextarea"
                                            class="textarea log-textarea w-full h-full font-mono text-sm resize-none"
                                            :placeholder="$tt('等待错误日志...')"
                                            v-model="runtimeTextFail"
                                            readonly
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <div class="drawer drawer-end">
            <input id="log-summary-drawer" type="checkbox" class="drawer-toggle" v-model="isLogDrawerOpen" />
            <div class="drawer-content"></div>
            <div class="drawer-side z-40">
                <label for="log-summary-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="log-detail-drawer min-h-full w-full max-w-xl p-5 md:p-6 shadow-2xl">
                    <div class="flex items-start justify-between gap-4 border-b border-base-300/80 pb-4">
                        <div>
                            <div class="text-xs uppercase tracking-[0.24em] text-base-content/45">{{ $tt('Log Summary') }}</div>
                            <h3 class="mt-2 text-xl font-semibold text-base-content">
                                #{{ selectedLog.id || '-' }} · {{ $tt(selectedLog.action || '-') }}
                            </h3>
                            <div class="mt-2 text-sm text-base-content/55">
                                {{ selectedLog.user || '-' }} · {{ selectedLog.created_at || '-' }}
                            </div>
                        </div>
                        <button class="btn btn-sm btn-ghost" @click="closeLogDrawer">{{ $tt('关闭') }}</button>
                    </div>

                    <div class="space-y-5 pt-6">
                        <div class="grid gap-4 md:grid-cols-2">
                            <div class="rounded-[22px] bg-base-100/78 p-4 shadow-sm">
                                <div class="text-xs uppercase tracking-[0.18em] text-base-content/45">{{ $tt('等级') }}</div>
                                <div class="mt-2">
                                    <span class="badge border-0 font-medium" :class="levelBadgeClass(selectedLog.level)">
                                        {{ selectedLog.level || '-' }}
                                    </span>
                                </div>
                            </div>
                            <div class="rounded-[22px] bg-base-100/78 p-4 shadow-sm">
                                <div class="text-xs uppercase tracking-[0.18em] text-base-content/45">{{ $tt('状态') }}</div>
                                <div class="mt-2">
                                    <span :class="['badge border-0 font-medium', statusBadgeClass(selectedLog.status)]">
                                        {{ getStatusText(selectedLog.status) }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="rounded-[24px] border border-base-300/70 bg-base-100/82 p-5 shadow-sm">
                            <div class="text-sm font-semibold mb-3">{{ $tt('日志详情') }}</div>
                            <div class="text-sm leading-7 whitespace-pre-wrap break-words text-base-content/78">
                                {{ selectedLog.extra || '-' }}
                            </div>
                        </div>

                                <div class="rounded-[24px] border border-base-300/70 bg-base-100/82 p-5 shadow-sm">
                                    <div class="text-sm font-semibold mb-3">{{ $tt('基础信息') }}</div>
                            <div class="grid gap-3 md:grid-cols-2 text-sm">
                                <div>
                                    <div class="text-base-content/45">{{ $tt('ID') }}</div>
                                    <div class="mt-1 font-mono">#{{ selectedLog.id || '-' }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('用户') }}</div>
                                    <div class="mt-1">{{ selectedLog.user || '-' }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('操作类型') }}</div>
                                    <div class="mt-1">{{ $tt(selectedLog.action || '-') }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('创建时间') }}</div>
                                    <div class="mt-1">{{ selectedLog.created_at || '-' }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('结束时间') }}</div>
                                    <div class="mt-1">{{ selectedLog.complete_at || '-' }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('任务标识') }}</div>
                                    <div class="mt-1 font-mono break-all">{{ selectedLog.task_id || '-' }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('选择模式') }}</div>
                                    <div class="mt-1">{{ selectedLog.select_mode || '-' }}</div>
                                </div>
                                <div>
                                    <div class="text-base-content/45">{{ $tt('状态原值') }}</div>
                                    <div class="mt-1 font-mono">{{ selectedLog.status || '-' }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="selectedLog.extra" class="rounded-[24px] border border-base-300/70 bg-base-100/82 p-5 shadow-sm">
                            <div class="flex items-center justify-between gap-3">
                                <div class="text-sm font-semibold">{{ $tt('原始内容') }}</div>
                                <div class="badge badge-outline">{{ extraFormatLabel(selectedLog.extra) }}</div>
                            </div>
                            <pre class="mt-4 whitespace-pre-wrap break-words rounded-[20px] bg-base-200/88 p-4 text-xs leading-6">{{ formatExtraPayload(selectedLog.extra) }}</pre>
                        </div>

                        <div v-if="canViewDetail(selectedLog.action)" class="flex justify-end">
                            <button class="btn btn-primary" @click="handleRedirect(selectedLog)">
                                {{ $tt('进入详情页') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <dialog id="download_log" ref="download_log" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold mb-4">{{ $tt('反馈日志') }}</h3>
                <div class="form-control mb-4">
                    <label class="label">
                        <span class="label-text">{{ $tt('反馈内容') }}</span>
                    </label>
                    <textarea
                        class="textarea textarea-bordered h-32"
                        :placeholder="$tt('请详细描述您遇到的问题，这将帮助开发者快速定位和解决问题（至少20字）')"
                        v-model="reason"
                    ></textarea>
                </div>
                <div class="alert alert-info mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span class="text-sm">{{ $tt('系统会同时上传相关日志文件给开发者进行分析') }}</span>
                </div>
                <div class="modal-action">
                    <form method="dialog" class="flex space-x-2">
                        <button class="btn btn-primary" @click="handleUploadLog">
                            {{ $tt('提交反馈') }}
                        </button>
                        <button class="btn">{{ $tt('取消') }}</button>
                    </form>
                </div>
            </div>
            <form method="dialog" class="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

const DETAIL_ACTION_ALIASES = {
    importLibrary: ['导入收藏', 'import library', 'import_library', 'import-music'],
    autoScrape: ['自动刮削', 'auto scrape', 'auto_scrape', 'auto-tag'],
    backendScrape: ['后台刮削', 'backend scrape', 'backend_scrape'],
    duplicateCheck: ['重复检查', 'duplicate check', 'duplicate_check'],
    manualEdit: ['手动修改', 'manual edit', 'manual_edit'],
    tidyFolder: ['整理文件夹', 'tidy folder', 'tidy_folder'],
    scrapeArtist: ['刮削艺术家', 'scrape artist', 'scrape_artist'],
    removeEmptyFolder: ['删除空文件夹', 'remove empty folder', 'remove_empty_folder'],
    splitText: ['拆分文本', 'split text', 'split_text'],
    replaceText: ['替换文本', 'replace text', 'replace_text'],
    formatConvert: ['格式转换', 'format convert', 'format_convert'],
    splitTrack: ['切割音轨', 'split track', 'split_track'],
    garbledFix: ['乱码修复', 'garbled fix', 'garbled_fix'],
    replayGain: ['回放增益', 'replay gain', 'replay_gain'],
    generateStrm: ['生成strm文件', 'generate strm file', 'generate_strm_file', 'generate_strm'],
    deleteLibrary: ['删除收藏', 'delete library', 'delete_library'],
    mergeArtists: ['合并相似艺术家', 'merge similar artists', 'merge_artists'],
    aiCandidate: ['AI候选', 'ai candidate', 'ai_candidate']
}

const ACTION_META = {
    importLibrary: { badge: 'Import', tone: 'info', description: '导入收藏相关的执行记录与异常信息。' },
    autoScrape: { badge: 'Auto', tone: 'success', description: '自动刮削任务的执行结果与状态变化。' },
    backendScrape: { badge: 'Queue', tone: 'accent', description: '后台异步刮削任务的运行记录。' },
    duplicateCheck: { badge: 'Check', tone: 'warning', description: '重复检查流程中的比对结果和处理记录。' },
    manualEdit: { badge: 'Edit', tone: 'info', description: '人工编辑元数据后的变更日志。' },
    tidyFolder: { badge: 'Folder', tone: 'neutral', description: '整理文件夹流程的执行记录。' },
    scrapeArtist: { badge: 'Artist', tone: 'accent', description: '艺术家刮削相关的任务和处理结果。' },
    removeEmptyFolder: { badge: 'Clean', tone: 'warning', description: '删除空文件夹的清理任务记录。' },
    splitText: { badge: 'Split', tone: 'neutral', description: '拆分文本类操作的处理日志。' },
    replaceText: { badge: 'Replace', tone: 'neutral', description: '替换文本规则执行后的记录。' },
    formatConvert: { badge: 'Format', tone: 'info', description: '格式转换流程中的操作和异常。' },
    splitTrack: { badge: 'Track', tone: 'accent', description: '切割音轨任务的处理记录。' },
    garbledFix: { badge: 'Fix', tone: 'warning', description: '乱码修复流程的结果与状态。' },
    replayGain: { badge: 'Gain', tone: 'info', description: '回放增益计算和写入相关日志。' },
    generateStrm: { badge: 'STRM', tone: 'success', description: '生成 strm 文件任务的执行记录。' },
    deleteLibrary: { badge: 'Delete', tone: 'error', description: '删除收藏操作的执行结果。' },
    mergeArtists: { badge: 'Merge', tone: 'accent', description: '合并相似艺术家任务的处理日志。' },
    aiCandidate: { badge: 'AI', tone: 'success', description: 'AI 候选相关的判断与处理记录。' }
}

const RUNTIME_OPTIONS = [
    {
        value: 'gunicorn',
        label: 'Gunicorn',
        badge: 'Web',
        tone: 'success',
        description: 'Web 进程日志，主要用于排查接口请求和服务异常。'
    },
    {
        value: 'worker',
        label: 'Worker',
        badge: 'Async',
        tone: 'accent',
        description: '异步任务执行日志，适合查看 Celery 后台处理过程。'
    },
    {
        value: 'beat',
        label: 'Beat',
        badge: 'Scheduler',
        tone: 'info',
        description: '定时任务调度日志，用于检查计划任务是否正常触发。'
    },
    {
        value: 'redis',
        label: 'Redis',
        badge: 'Cache',
        tone: 'warning',
        description: '缓存与队列服务日志，适合定位连接与缓存层异常。'
    },
    {
        value: 'xiaoai',
        label: 'Xiaoai',
        badge: 'Device',
        tone: 'neutral',
        description: '小爱相关服务日志，用于检查设备联动和指令处理。'
    }
]

export default {
    name: 'Log',
    data() {
        return {
            size: 'small',
            auditLogData: [],
            tabSelectRuntime: 'gunicorn',
            tabSelect2: 'log',
            runtimeText: '',
            runtimeTextFail: '',
            pollInterval: 5,
            isPolling: true,
            pollingTimer: null,
            currentPage: 1,
            hasNextPage: true,
            jumpPage: 1,
            reason: '',
            totalRecords: 0,
            levelFilter: '',
            statusFilter: '',
            userFilter: '',
            isLogDrawerOpen: false,
            selectedLog: {},
            actionStatsCache: {}
        }
    },
    computed: {
        ...mapGetters(['getUserRole']),
        tabSelect: {
            get() {
                return this.$store.state.log.tabSelect
            },
            set(value) {
                this.$store.dispatch('log/setTabSelect', value)
            }
        },
        actionOptions() {
            return [
                {
                    key: 'all',
                    value: '',
                    aliases: [],
                    label: '全部操作',
                    badge: 'All',
                    tone: 'neutral',
                    description: '汇总展示全部任务行为，适合排查最近的整体执行情况。'
                },
                ...Object.entries(DETAIL_ACTION_ALIASES).map(([key, aliases]) => {
                    const meta = ACTION_META[key] || {}
                    return {
                        key,
                        value: aliases[0],
                        aliases,
                        label: aliases[0],
                        badge: meta.badge || 'Log',
                        tone: meta.tone || 'neutral',
                        description: meta.description || '当前分类包含该类型的操作记录。'
                    }
                })
            ]
        },
        visibleActionOptions() {
            return this.actionOptions.filter((item) => {
                if (item.key === 'all') {
                    return true
                }
                return this.getActionCount(item.key) > 0
            })
        },
        currentActionKey() {
            if (!this.tabSelect) {
                return 'all'
            }
            const exactMatch = this.actionOptions.find((item) => item.key === this.tabSelect)
            if (exactMatch) {
                return exactMatch.key
            }
            const legacyMatch = this.actionOptions.find((item) => item.aliases.includes(this.tabSelect))
            return legacyMatch ? legacyMatch.key : 'all'
        },
        runtimeOptions() {
            return RUNTIME_OPTIONS
        },
        activeActionOption() {
            return this.actionOptions.find((item) => item.key === this.currentActionKey) || this.actionOptions[0]
        },
        activeRuntimeOption() {
            return this.runtimeOptions.find((item) => item.value === this.tabSelectRuntime) || this.runtimeOptions[0]
        },
        activeModeTitle() {
            return this.tabSelect2 === 'log' ? this.$tt('操作日志概览') : this.$tt('运行日志面板')
        },
        activeModeBadge() {
            return this.tabSelect2 === 'log' ? this.$tt('Log Stream') : this.$tt('Runtime Stream')
        },
        modeBadgeClass() {
            return this.tabSelect2 === 'log' ? 'bg-info/12 text-info' : 'bg-success/12 text-success'
        },
        summaryPrimaryText() {
            if (this.tabSelect2 === 'log') {
                return this.$tt('共 {count} 条', { count: this.totalRecords })
            }
            return this.$tt('服务 {name}', { name: this.activeRuntimeOption.label })
        },
        summarySecondaryText() {
            if (this.tabSelect2 === 'log') {
                return this.$tt('当前页 {page} / 本页 {count} 条', { page: this.currentPage, count: this.auditLogData.length })
            }
            return this.isPolling ? this.$tt('轮询 {sec} 秒', { sec: this.pollInterval }) : this.$tt('轮询已暂停')
        },
        summaryTertiaryText() {
            if (this.tabSelect2 === 'log') {
                return this.$tt('筛选 {text}', { text: this.filterSummaryText })
            }
            return this.$tt('错误面板已同步')
        },
        activeModeHint() {
            return this.tabSelect2 === 'log'
                ? this.$tt('左侧固定操作上下文，右侧只查看当前筛选下的日志列表。')
                : this.$tt('左侧切换服务，右侧同步查看运行输出与错误输出。')
        },
        runtimeSourceHint() {
            return this.$tt('服务源') + ': ' + this.activeRuntimeOption.label
        },
        activeActionLabel() {
            return this.$tt(this.activeActionOption.label)
        },
        activeActionDescription() {
            return this.$tt(this.activeActionOption.description)
        },
        activeRuntimeLabel() {
            return this.activeRuntimeOption.label
        },
        activeRuntimeDescription() {
            return this.$tt(this.activeRuntimeOption.description)
        },
        headerAccentWidth() {
            if (this.tabSelect2 === 'runtime') {
                return this.isPolling ? 100 : 42
            }
            if (!this.totalRecords) {
                return 18
            }
            return Math.max(18, Math.min(100, Math.round((this.currentPage / Math.max(1, Math.ceil(this.totalRecords / 50))) * 100)))
        },
        pageAccentBarClass() {
            return this.tabSelect2 === 'log' ? 'bg-info/25' : 'bg-success/25'
        },
        filterSummaryText() {
            const summary = []
            if (this.currentActionKey !== 'all') {
                summary.push(this.$tt(this.activeActionOption.label))
            }
            if (this.levelFilter) {
                summary.push(this.$tt(this.levelFilter === 'info' ? '信息' : this.levelFilter === 'warning' ? '警告' : '错误'))
            }
            if (this.statusFilter) {
                summary.push(this.getStatusText(this.statusFilter))
            }
            if (this.userFilter) {
                summary.push(this.userFilter)
            }
            return summary.length ? summary.join(' / ') : this.$tt('全部')
        }
    },
    created() {
        if (this.currentActionKey !== this.tabSelect) {
            this.tabSelect = this.currentActionKey === 'all' ? '' : this.currentActionKey
        }
        this.fetchAuditLog()
    },
    beforeDestroy() {
        this.clearPollingTimer()
    },
    methods: {
        normalizeActionName(action) {
            return String(action || '')
                .trim()
                .toLowerCase()
                .replace(/[_-]/g, ' ')
                .replace(/\s+/g, ' ')
        },
        canViewDetail(action) {
            const normalizedAction = this.normalizeActionName(action)
            return Object.values(DETAIL_ACTION_ALIASES).some((aliases) =>
                aliases.some((alias) => this.normalizeActionName(alias) === normalizedAction)
            )
        },
        getStatusText(status) {
            const statusMap = {
                running: '进行中',
                success: '成功',
                stop: '停止',
                failed: '失败',
                wait: '等待'
            }
            return this.$tt(statusMap[status] || status || '-')
        },
        statusBadgeClass(status) {
            const classMap = {
                running: 'bg-info/14 text-info',
                wait: 'bg-info/14 text-info',
                success: 'bg-success/14 text-success',
                stop: 'bg-warning/18 text-warning',
                failed: 'bg-error/14 text-error'
            }
            return classMap[status] || 'bg-base-200 text-base-content/65'
        },
        levelBadgeClass(level) {
            const classMap = {
                info: 'bg-base-200 text-base-content/70',
                warning: 'bg-warning/18 text-warning',
                error: 'bg-error/14 text-error'
            }
            return classMap[level] || 'bg-base-200 text-base-content/65'
        },
        navRowClass(active) {
            return active ? 'bg-info/10 ring-1 ring-info/30' : 'hover:bg-base-200/70'
        },
        softBadgeClass(tone) {
            const map = {
                success: 'bg-success/12 text-success',
                info: 'bg-info/12 text-info',
                warning: 'bg-warning/16 text-warning',
                error: 'bg-error/12 text-error',
                accent: 'bg-accent/12 text-accent',
                neutral: 'bg-base-200 text-base-content/70',
                ghost: 'bg-base-200 text-base-content/60'
            }
            return map[tone] || map.neutral
        },
        selectAction(actionKey) {
            this.tabSelect = actionKey === 'all' ? '' : actionKey
            this.currentPage = 1
            this.jumpPage = 1
            this.fetchAuditLog()
        },
        selectRuntime(value) {
            this.tabSelectRuntime = value
            this.fetchRuntimeLog()
        },
        handlePageChange(page) {
            const targetPage = Number(page)
            if (!targetPage || targetPage < 1) {
                return
            }
            this.currentPage = targetPage
            this.jumpPage = targetPage
            this.fetchAuditLog()
        },
        fetchAuditLog() {
            const params = {
                page: this.currentPage,
                page_size: 50
            }

            if (this.currentActionKey !== 'all') params.action_group = this.currentActionKey
            if (this.levelFilter) params.level = this.levelFilter
            if (this.statusFilter) params.status = this.statusFilter
            if (this.userFilter) params.user = this.userFilter

            this.$api.Task.getAuditLog(params).then(res => {
                if (res.result) {
                    this.auditLogData = res.data.items
                    this.hasNextPage = res.data.count > this.currentPage * 50
                    this.totalRecords = res.data.count
                    this.actionStatsCache = Object.entries(res.data.action_stats || {}).reduce((acc, [key, count]) => {
                        acc[key] = { count }
                        return acc
                    }, {})
                }
            })
        },
        fetchRuntimeLog() {
            this.$api.Task.getRuntimeLog({ type: this.tabSelectRuntime }).then(res => {
                if (res.result) {
                    this.runtimeText = res.data.log
                    this.runtimeTextFail = res.data.fail_log
                    this.$nextTick(() => {
                        if (this.$refs.logTextarea) {
                            this.$refs.logTextarea.scrollTop = this.$refs.logTextarea.scrollHeight
                        }
                        if (this.$refs.failLogTextarea) {
                            this.$refs.failLogTextarea.scrollTop = this.$refs.failLogTextarea.scrollHeight
                        }
                    })
                }
            })
        },
        handleFilterChange() {
            this.currentPage = 1
            this.jumpPage = 1
            this.fetchAuditLog()
        },
        resetFilters() {
            this.tabSelect = ''
            this.levelFilter = ''
            this.statusFilter = ''
            this.userFilter = ''
            this.currentPage = 1
            this.jumpPage = 1
            this.fetchAuditLog()
        },
        handleTab2(v) {
            if (this.tabSelect2 === v) {
                return
            }
            this.tabSelect2 = v
            if (v === 'log') {
                this.clearPollingTimer()
                this.currentPage = 1
                this.jumpPage = 1
                this.fetchAuditLog()
            } else {
                this.fetchRuntimeLog()
                if (this.isPolling) {
                    this.startPolling()
                }
            }
        },
        handleRedirect(item) {
            if (this.getUserRole === 'V2') {
                this.$router.push({ path: '/log_detail/' + item.id + '/' })
            } else {
                this.$myMsg.notify({
                    title: this.$tt('权限失败'),
                    content: this.$tt('V1 版本：您没有该功能的操作权限'),
                    type: 'error',
                    time: 3000
                })
            }
        },
        openLogDrawer(item) {
            this.selectedLog = { ...item }
            this.isLogDrawerOpen = true
        },
        closeLogDrawer() {
            this.isLogDrawerOpen = false
        },
        getUserInitial(user) {
            const value = String(user || '').trim()
            return value ? value.charAt(0).toUpperCase() : '?'
        },
        formatCreatedTime(createdAt) {
            if (!createdAt) {
                return '-'
            }
            const parts = String(createdAt).split(' ')
            return parts.length > 1 ? parts[1] : parts[0]
        },
        getActionCount(actionKey) {
            const stats = this.actionStatsCache[actionKey]
            return stats ? stats.count : 0
        },
        getActionCountValue(actionKey) {
            const stats = this.actionStatsCache[actionKey]
            if (!stats) {
                return '--'
            }
            return stats.count
        },
        getActionCountLabel(actionKey) {
            const stats = this.actionStatsCache[actionKey]
            if (!stats) {
                return this.$tt('未加载')
            }
            return this.$tt('总数')
        },
        formatExtraPayload(value) {
            if (value === null || value === undefined || value === '') {
                return '-'
            }
            if (typeof value === 'object') {
                try {
                    return JSON.stringify(value, null, 2)
                } catch (error) {
                    return String(value)
                }
            }
            const text = String(value)
            try {
                return JSON.stringify(JSON.parse(text), null, 2)
            } catch (error) {
                return text
            }
        },
        extraFormatLabel(value) {
            if (value && typeof value === 'object') {
                return 'JSON'
            }
            try {
                JSON.parse(String(value || ''))
                return 'JSON'
            } catch (error) {
                return 'TEXT'
            }
        },
        openDownloadDialog() {
            if (this.$refs.download_log && typeof this.$refs.download_log.showModal === 'function') {
                this.$refs.download_log.showModal()
            }
        },
        togglePolling() {
            if (this.isPolling) {
                this.stopPolling()
            } else {
                this.startPolling()
            }
        },
        startPolling() {
            this.clearPollingTimer()
            this.isPolling = true
            this.fetchRuntimeLog()
            this.pollingTimer = setInterval(() => {
                this.fetchRuntimeLog()
            }, Math.max(1, Number(this.pollInterval) || 5) * 1000)
        },
        stopPolling() {
            this.isPolling = false
            this.clearPollingTimer()
        },
        clearPollingTimer() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
                this.pollingTimer = null
            }
        },
        handleUploadLog() {
            if (this.reason.length < 20) {
                this.$myMsg.notify({
                    title: this.$tt('反馈失败！'),
                    content: this.$tt('反馈理由至少20字'),
                    type: 'error',
                    time: 3000
                })
                return
            }
            this.$api.Task.uploadLog({
                reason: this.reason
            }).then(res => {
                if (res.result) {
                    this.$refs.download_log.close()
                    this.reason = ''
                    this.$myMsg.notify({
                        title: this.$tt('反馈成功！'),
                        type: 'success',
                        time: 3000
                    })
                }
            })
        },
        handleDeleteAuditLogs() {
            this.$api.Task.createPeriodicTask({ name: 'audit_log', type: 'manual', enabled: true }).then(res => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('删除任务已提交'),
                        content: this.$tt('日志正在后台删除中，请稍后刷新查看'),
                        type: 'success',
                        time: 3000
                    })
                }
            }).catch(() => {
                this.$myMsg.notify({
                    title: this.$tt('提交失败'),
                    content: this.$tt('网络错误或服务器异常'),
                    type: 'error',
                    time: 3000
                })
            })
        }
    }
}
</script>

<style scoped>
.log-overview-shell {
    background: linear-gradient(
        180deg,
        oklch(var(--b2) / 0.42) 0%,
        oklch(var(--b1) / 0.94) 100%
    );
}

.log-overview-sidebar {
    background: linear-gradient(
        180deg,
        oklch(var(--b2) / 0.72) 0%,
        oklch(var(--b1) / 0.98) 100%
    );
}

.log-overview-detail {
    background: linear-gradient(
        180deg,
        oklch(var(--b1)) 0%,
        oklch(var(--b2) / 0.22) 100%
    );
}

.log-overview-table thead tr {
    background: oklch(var(--b2) / 0.58);
}

.log-overview-table tbody tr {
    transition: background-color 180ms ease;
}

.log-overview-table tbody tr:hover {
    background: oklch(var(--b2) / 0.36);
}

.log-overview-table th,
.log-overview-table td {
    vertical-align: top;
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.log-overview-table thead th {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: oklch(var(--bc) / 0.58);
    white-space: nowrap;
}

.log-detail-drawer {
    background: linear-gradient(
        180deg,
        oklch(var(--b2)) 0%,
        oklch(var(--b1)) 100%
    );
}

.scrape-action-btn {
    white-space: nowrap;
    flex-shrink: 0;
    border-radius: 9999px;
    padding: 0.2rem 0.65rem;
    color: oklch(var(--bc) / 0.62);
    background: oklch(var(--b2) / 0.55);
    transition: background-color 180ms ease, color 180ms ease;
}

.scrape-action-btn:hover {
    color: oklch(var(--bc) / 0.9);
    background: oklch(var(--b2) / 0.88);
}

.scrape-action-btn--strong {
    color: oklch(var(--p) / 0.8);
}

.log-summary-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.log-textarea {
    border-radius: 1.25rem;
    background: oklch(var(--b1) / 0.88);
    border-color: oklch(var(--b3) / 0.72);
}

.log-textarea,
.log-overview-sidebar,
.log-overview-detail {
    scrollbar-width: none;
}

.log-textarea::-webkit-scrollbar,
.log-overview-sidebar::-webkit-scrollbar,
.log-overview-detail::-webkit-scrollbar {
    width: 6px;
    background: transparent;
}

.log-textarea::-webkit-scrollbar-track,
.log-overview-sidebar::-webkit-scrollbar-track,
.log-overview-detail::-webkit-scrollbar-track {
    background: transparent;
}

.log-textarea::-webkit-scrollbar-thumb,
.log-overview-sidebar::-webkit-scrollbar-thumb,
.log-overview-detail::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 9999px;
    transition: background 200ms ease;
}

.log-textarea:hover::-webkit-scrollbar-thumb,
.log-overview-sidebar:hover::-webkit-scrollbar-thumb,
.log-overview-detail:hover::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.18);
}

.log-textarea:hover::-webkit-scrollbar-thumb:hover,
.log-overview-sidebar:hover::-webkit-scrollbar-thumb:hover,
.log-overview-detail:hover::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.28);
}

@media (max-width: 1279px) {
    .log-overview-table {
        min-width: 960px;
    }
}

@media (max-width: 1023px) {
    .card {
        height: calc(100vh - 5rem);
    }
}

@media (max-width: 767px) {
    .log-detail-drawer {
        max-width: 100%;
    }
}
</style>
